import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import * as Constants from '@emi/shared/constants';
import { FocusableOption } from '@angular/cdk/a11y';
import { TimeSeriesPrice, TimeSeriesSku } from '../../models';
import { TimeSeriesIndices } from '../sku-time-series-table.component';
import { Router } from '@angular/router';
import { ConfigureData } from '@emi/shared/models';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { getSelectedConfigureData } from '@emi/shared/state/filters';
import { environment } from '../../../../../../../../apps/via-shell/src/environments/environment';

@Component({
    selector: 'via-sku-time-series-table-row',
    templateUrl: './sku-time-series-table-row.component.html',
    styleUrls: ['./sku-time-series-table-row.component.scss'],
})
export class SkuTimeSeriesTableRowComponent implements FocusableOption {
    @ViewChild('row')
    public row: ElementRef;
    @Input()
    public isShowingAllPrices: boolean;

    @Input()
    public showRegularPrice: boolean;

    @Input()
    public data: TimeSeriesSku;

    @Input()
    public selectedSortType: string;

    @Input()
    public timeSeriesIndices: TimeSeriesIndices;

    @Input()
    public imageSasParams: string;

    public noImagePlaceholderUrl = Constants.GlobalVariables.PLACEHOLDER_45x65;
    public blobStorageUrl: string = environment.imagesUrl + Constants.GlobalVariables.SKU_IMAGES_SMALL;

    public readonly config$: Observable<ConfigureData> = this.store.select(getSelectedConfigureData);

    constructor(private store: Store, private router: Router) { }

    public getPriceGrowthText(priceGrowth: number | undefined): string {
        if (priceGrowth !== undefined) {
            return priceGrowth < 0 ? `${priceGrowth}%` : `+${priceGrowth}%`;
        }
        return Constants.TimeSeriesGrid.NOT_CALCULATED_LABEL;
    }

    public getToolTipMessage(priceGrowth: number | undefined){
      if (priceGrowth === undefined){
        return Constants.TimeSeriesGrid.NOT_CALCULATED_TOOLTIP
      }
      return undefined
    }

    public getPriceGrowthClassName(priceGrowth: number | undefined): string {
        if (priceGrowth !== undefined) {
            return priceGrowth < 0
                ? Constants.TimeSeriesGrid.ClassNames.NEGATIVE_GROWTH
                : Constants.TimeSeriesGrid.ClassNames.POSITIVE_GROWTH;
        }
        return '';
    }

    public getCellStyles(priceChangePercent: number): Object {
        const cellStyles = {
            backgroundColor: '',
            borderColor: 'transparent',
            color: '',
        };

        if (priceChangePercent > 0) {
            cellStyles.backgroundColor =
                priceChangePercent >= Constants.TimeSeriesGrid.MAX_SATURATION_PERCENT
                    ? `rgb(${Constants.TimeSeriesGrid.Colours.POSITIVE_CHANGE})`
                    : `rgba(${Constants.TimeSeriesGrid.Colours.POSITIVE_CHANGE}, ${priceChangePercent / 10})`;
        } else {
            cellStyles.backgroundColor =
                priceChangePercent <= -Constants.TimeSeriesGrid.MAX_SATURATION_PERCENT
                    ? `rgb(${Constants.TimeSeriesGrid.Colours.NEGATIVE_CHANGE})`
                    : `rgba(${Constants.TimeSeriesGrid.Colours.NEGATIVE_CHANGE}, ${-priceChangePercent / 10})`;
        }

        cellStyles.color =
            Math.abs(priceChangePercent) > Constants.TimeSeriesGrid.TEXT_COLOUR_SWITCH_PERCENT
                ? Constants.TimeSeriesGrid.Colours.LIGHT_TEXT
                : Constants.TimeSeriesGrid.Colours.DARK_TEXT;

        return cellStyles;
    }

    public getCellClassName(price: TimeSeriesPrice): string {
        if (price.isOutOfStock) {
            return Constants.TimeSeriesGrid.ClassNames.OUT_OF_STOCK;
        }

        // TODO: add conditions for discount on/off

        return '';
    }

    public focus(): void {
        this.row.nativeElement.focus();
    }

    public handleMissingImage(name: string) {
        document.getElementById(name)?.setAttribute('src', this.noImagePlaceholderUrl);
    }

    public getSkuCapsule(id: number): void {
      this.router.navigate([Constants.Routes.SKU_SEARCH_SKU], { queryParams: { id: id } });
  }

}
